/* Auth Service
 ** Author: Soc-dfsk -30
 ** Version: 1.0
 ** Date 10/01/2017 */


'use strict';

App.service('authApi', authApi);

function authApi($http, $q, $localStorage, $state, Api, $loading, ngDialog, $sessionStorage) {
    /*this.Login = Login;*/
    this.getToken = getToken;
    this.logout = logout;
    this.setToken = setToken;
    var dialogId;
    function setToken(token) {
        $localStorage['token'] = token;
    }

    function getToken() {
        return $localStorage['token'];
    }

    function logout() {     
        dialogId = ngDialog.open({
            template: 'prnJobInfoPopup',
            className: 'ngdialog-theme-default documentation-dialog prn-dialog incompleteDashboard',
            closeByNavigation: true,
            showClose: false,
            closeByDocument: false,
            closeByEscape: false,
            controller: ['$scope', 'userService', '$sessionStorage', '$localStorage', '$state', 'sessionTimeout', 'errorHandler',
                function($scope, userService, $sessionStorage, $localStorage, $state, sessionTimeout, errorHandler) {
                $scope.logoutFunction = function(){
                    userService.logout($localStorage['token']);
                    const coBrandedToken = $localStorage['coBrandedKEY'];
                    $localStorage.$reset();
                    $sessionStorage.$reset();
                    sessionTimeout.stop();
                    errorHandler.stop();
                    if(coBrandedToken){
                        $localStorage['coBrandedKEY'] = coBrandedToken;
                        return $state.go('coBrandedLogin', { coBrandedKEY: coBrandedToken });
                    }
                    $state.go('login');
                };
                $scope.cancelLogout = function(){
                    ngDialog.closeAll();
                };
            }]
        });
    }
}
